import { Theme, ThemeOptions } from '@mui/material';
import { BoxShadows } from './boxShadows';
import { colors, colorsType } from './colors';
import { ButtonVariant } from './types';

export const buttonStyles = (_theme: Theme): ThemeOptions => ({
  components: {
    // Buttons
    MuiButton: {
      defaultProps: {
        disableElevation: true,
        focusRipple: false,
      },
      styleOverrides: {
        root: {
          lineHeight: 1.5,
          padding: '.75rem 1.25rem',
          borderRadius: '.25rem',
          ':focus': {
            boxShadow: BoxShadows.btnFocus,
          },
        },
        sizeSmall: {
          padding: '.5rem 1rem',
          height: '2.5rem',
          fontSize: '0.875rem',
        },
        sizeMedium: {
          height: '3rem',
        },
      },
      variants: [
        {
          props: { variant: 'default' },
          style: {
            border: `1px solid ${colors.grey[200]}`,
            color: colors.primary.main,
          },
        },
        {
          props: { variant: 'light' },
          style: {
            '&.MuiButton-light': {
              backgroundColor: colors.primary.light,
              color: colors.primary.main,
              ':hover': {
                backgroundColor: colors.primary.main,
                color: colors.common.white,
              },
              ':disabled': {
                backgroundColor: colors.primary.light,
                color: colors.grey[400],
              },
            },
          },
        },
        ...colorsType.map<ButtonVariant>((color) => ({
          props: { variant: 'default', color },
          style: {
            color: colors[color].main,
          },
        })),
        ...colorsType.map<ButtonVariant>((color) => ({
          props: { variant: 'light', color },
          style: {
            '&.MuiButton-light': {
              backgroundColor: colors[color].light,
              color: colors[color].dark,
              ':hover': {
                backgroundColor: colors[color].main,
                color: colors.common.white,
              },
              ':disabled': {
                backgroundColor: colors[color].light,
                color: colors.grey[400],
              },
            },
          },
        })),
        {
          props: { variant: 'social' },
          style: {
            '&.MuiButton-social': {
              backgroundColor: colors.common.white,
              borderRadius: '30rem',
              border: `1px solid ${colors.secondary.main}`,
              padding: '0.75rem 1rem',
              height: '44px',
              ':hover': {
                backgroundColor: colors.secondary.light,
                color: colors.primary.dark,
              },
              ':disabled': {
                borderColor: colors.secondary.light,
                color: colors.grey[400],
              },
            },
          },
        },
        {
          props: { variant: 'link' },
          style: {
            padding: '0 0.25rem',
            backgroundColor: 'transparent',
            color: colors.primary.main,
            ':hover': {
              textDecoration: 'underline',
              backgroundColor: 'initial',
            },
          },
        },
      ],
    },

    MuiIconButton: {
      styleOverrides: {
        root: {
          ':focus': {
            boxShadow: BoxShadows.btnFocus,
          },
        },
      },
    },

    MuiLoadingButton: {
      styleOverrides: {
        loadingIndicator: {
          width: '100%',
          padding: 'inherit',
          justifyContent: 'center',
        },
      },
    },
  },
});
